/* eslint-disable @typescript-eslint/no-unnecessary-condition -- runtime safety for test environments */
import { getUrlsTable } from '@repo/shared-config/app/constants/hosts';
import { getEnvironmentVariables } from '@repo/shared-config/app/helper/environment-variables';

// backendUrlsTable can be undefined at runtime when environment variables are not available
// (e.g., in unit tests without DOM/meta tags), even though TypeScript types say otherwise
const { backendUrlsTable, frontendUrlsTable } = getUrlsTable(getEnvironmentVariables());

export const apiBaseURL = backendUrlsTable?.apiBaseURL ?? '';
export const registerBaseURL = backendUrlsTable?.registerBaseURL ?? '';
export const registerPartnersBaseURL = backendUrlsTable?.registerPartnersBaseURL ?? '';
export const billerBaseURL = backendUrlsTable?.billerBaseURL ?? '';

// API namespaces
export const BILLER_V2_NAMESPACE = 'v2';
export const billerNamespace = 'v1';
export const cardAcquirerNamespace = 'card_acquirer/v1';
export const registerNamespace = 'v1';
export const registerPartnersNamespace = 'client_api';

// Frontend URLs
export const appJsURL = frontendUrlsTable?.appJsURL ?? '';
export const companyCreationJsURL = frontendUrlsTable?.companyCreationJsURL ?? '';
